import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../Button'

const InvitationActionBlock = ({getKey, acceptInvitation}) => (
  <>
    <h2 key={getKey()} className="mb-4 md:w-1/2 mt-5">
      <FormattedMessage id="booking.amountForm.invitation.loggedOutDesc" defaultMessage="If you don’t have an account, don’t worry, you can still confirm you spot." />
    </h2>
    <div key={getKey()} className="flex justify-end border-b pb-8">
      <Button onClick={acceptInvitation} type="button">
        <FormattedMessage id="booking.amountForm.invitation.loggedOutButton" defaultMessage="New user" />
      </Button>
    </div>
  </>
)
  
export default InvitationActionBlock